import { render } from "./AdminPageHeader.vue?vue&type=template&id=26b5be41&scoped=true"
import script from "./AdminPageHeader.vue?vue&type=script&lang=js"
export * from "./AdminPageHeader.vue?vue&type=script&lang=js"

import "./AdminPageHeader.vue?vue&type=style&index=0&id=26b5be41&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b5be41"]])

export default __exports__